import * as React from 'react';
import { IActions, actionCreator } from './store/action/creators';
import { IActions as IActionTags, actionCreator as tagsActionCreators } from '../tags/store/actions/creators';
import { actionCreator as trainerActions, IActions as ITrainersActions } from '../../common/store/trainers/actions/creators'
import { Grid, StyledComponentProps, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { IState } from './store/state';
import moment from 'moment';
import { BigCalendar, CalendarEvent } from '../../ui-components/BigCalendar/BigCalendar';
import { stringOrDate } from 'react-big-calendar';
import { ActivitySchedule, ActivityDefinition, ActivityState } from '../../model/activities';
import { EmptyEventComponent } from '../../ui-components/BigCalendar/eventDetails/EmptyEventComponent';
import { CalendarDetail } from '../../ui-components/BigCalendar/eventDetails/CalendarDetail';
import { tag } from '../../model/tag';
import { trainer } from '../../model/trainer';

interface IProps extends StyledComponentProps, IMediaQueryProps, IActions, IState, IActionTags, ITrainersActions {
    allActivities: ActivityDefinition[];
    allTags: tag[];
    allTrainers: trainer[];
}

interface IInternalState {
    currentActivityDefinition?: ActivityDefinition;
    currentEvent?: CalendarEvent;
    currentState?: ActivityState;
    from: Date;
    to: Date;
}
const getMonday = (d: Date) => {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

const getSunday = (d: Date) => {
    var ret = new Date(d || new Date());
    ret.setDate(ret.getDate() + (6 - ret.getDay() + 7) % 7 + 1);
    return ret;
}
const translateState = (state: string) => {
    if (state === "all")
        return undefined;
    if (state === "approved")
        return ActivityState.approved;
    if (state === "draft")
        return ActivityState.draft;
}
const translateState2 = (state?: ActivityState) => {
    if (state === undefined)
        return "all";
    if (state === ActivityState.approved)
        return 'approved';
    if (state === ActivityState.draft)
        return 'draft';
}
class ReservationContainer extends React.Component<IProps, IInternalState>
{
    constructor(p, c) {
        super(p, c);
        this.state = { from: getMonday(new Date()), to: getSunday(new Date()) }
    }


    componentDidMount() {
        if (!this.props.schedules || !this.props.schedules.length)
            this.props.getSchedules(this.state.from, this.state.to, this.state.currentState);
        if (!this.props.allActivities || !this.props.allActivities.length)
            this.props.loadAllActivities();
        if (!this.props.allTags || !this.props.allTags.length)
            this.props.loadTags();
        if (!this.props.allTrainers || !this.props.allTrainers.length)
            this.props.loadTrainers();
    }
    /*title: string;
        events: CalendarEvent[];
        views?: View[]
        defaultView: View;
        renderDetail: (e: CalendarEvent) => JSX.Element;
        renderEmptyDetail?: () => JSX.Element;
        onRangeChange?: (start: stringOrDate, end: stringOrDate) => void;
        selectedEvent?: CalendarEvent; */

    updateSchedule = (a: ActivitySchedule, updateSimilar: boolean) => {
        this.props.saveSchedule(a, updateSimilar);
    }
    createSchedule = (a: ActivitySchedule) => {
        if (!a.activityDefinitionId)
            a.state = ActivityState.approved;
        this.props.createSchedule(a);
    }
    deleteSchedule = (id: string) => {
        this.props.deleteSchedule(id);
    }
    onRangeChange = (start: stringOrDate, end: stringOrDate) => {
        let f, t;
        if (!(start instanceof Date))
            f = new Date(start);
        else f = start;
        if (!(end instanceof Date))
            t = new Date(end);
        else t = end;
        this.setState({ from: f, to: t });
        this.props.getSchedules(f, t, this.state.currentState);
    }

    getEventsCount = () => {
        if (this.props.schedules) {
            return this.props.schedules.length;
        }
        return 0;
    }
    onEventSelected = (e: CalendarEvent) => {
        const activity = this.props.allActivities.find(a => a._id === e.resource._id);
        this.setState({ currentActivityDefinition: activity });
    }
    changeFilter = (val: string) => {
        const state = translateState(val);
        this.setState({ currentState: state });
        this.props.getSchedules(this.state.from, this.state.to, state);
    }
    render() {
        return (
            <Grid container spacing={1}>
                <Grid item sm={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <FormLabel component="legend" style={{ marginRight: 10 }}>Stato: </FormLabel>
                    <RadioGroup style={{ display: 'flex', flexDirection: 'row' }} aria-label="filter" name="filter1" value={translateState2(this.state.currentState)} onChange={event => this.changeFilter(event.target.value)}>
                        <FormControlLabel value={"all"} control={<Radio />} label="Tutti" />
                        <FormControlLabel value={"draft"} control={<Radio />} label="Bozze" />
                        <FormControlLabel value={"approved"} control={<Radio />} label="Approvati" />
                    </RadioGroup>
                </Grid>
                <Grid item sm={12}>
                    <BigCalendar onRangeChange={this.onRangeChange}
                        height={640}
                        onEventSelected={this.onEventSelected}
                        renderEmptyDetail={() => <EmptyEventComponent
                            trainers={this.props.allTrainers}
                            onCreate={this.createSchedule}
                            events={this.getEventsCount()}
                            sourceActivity={this.state.currentActivityDefinition}
                            classes={this.props.classes}
                            allActivities={this.props.allActivities}
                            allTags={this.props.allTags} />}
                        renderDetail={e => <CalendarDetail
                            trainers={this.props.allTrainers}
                            onAddReservation={this.props.addReservation}
                            onRemoveReservation={this.props.removeReservation}
                            maxDate={this.state.currentActivityDefinition?.expiresOn}
                            minDate={this.state.currentActivityDefinition?.validFrom}
                            loading={this.props.isLoadingDetails}
                            onSave={this.updateSchedule}
                            onDelete={this.deleteSchedule}
                            event={e}
                            classes={this.props.classes} />}
                        views={['week', 'day', 'month']}
                        defaultView='week'
                        title='Prenotazioni attività'
                        events={(this.props.schedules || []).map(s => getEvent(s))}
                        loading={this.props.isLoading} />
                </Grid>
            </Grid>
        );
    }
}
const getEvent = (s: ActivitySchedule) => {
    if (s)
        return {
            start: s.date,
            end: moment(s.date).add(s.duration, 'm').toDate(),
            title: s.displayName,
            resource: s,
            color: s.tag?.color || 'green'
        }
    return undefined;
}
const mapStateToProps = (state: IApplicationState) => ({
    ...state.activityReservations,
    allActivities: [...state.activities.allActivities],
    allTags: [...state.tags.tags],
    allTrainers: [...state.trainers.trainers]
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        ...tagsActionCreators(dispatch),
        ...trainerActions(dispatch)
    }
};

export const ActivityReservations = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles as any)(WithMediaQuery(ReservationContainer)));